import React from "react";
import styles from "./ArchiveAppModal.module.css";

import { ReactComponent as ArchiveIcon } from "../../icons/Archive_Icon.svg";
import { ReactComponent as ArchiveCancel } from "../../icons/archive_cancel_btn.svg";
import { ReactComponent as ArchiveButton } from "../../icons/archive_archive_btn.svg";

/**
 * View Component for Archiving Apps
 */
export function ArchiveAppModal({ onClose, onSubmit, appNumber }) {
  const handleClose = (isSave) => {
    if (isSave) {
      onSubmit(appNumber);
    }
    onClose();
  };

  return (
    <div className={styles.modalBackground}>
      <div className={styles.modalContainer}>
        <div className={styles.modalRow}>
          <ArchiveIcon />
        </div>

        <div className={styles.modalRow}>
          <span className={styles.modalTitle}>
            Are you sure you want to archive this app? All references to these
            categories will be removed.
          </span>
        </div>

        <span className={styles.buttonSpan}>
          <button
            className={styles.archiveButtons}
            onClick={() => handleClose(false)}
          >
            <ArchiveCancel />
          </button>
          <button
            className={styles.archiveButtons}
            onClick={() => handleClose(true)}
          >
            <ArchiveButton />
          </button>
        </span>
      </div>
    </div>
  );
}
